import { css, type Theme } from "@emotion/react";

import * as animations from "@styles/emotion-styles/animations";

export const productName = {
  base: css`
    text-overflow: ellipsis;
    overflow: hidden;
    ${animations.transition()}

    &&& {
      margin-bottom: 0;
    }
  `,

  changeOnHover: (theme: Theme) => css`
    &:focus,
    &:hover {
      color: ${theme.success.textBase};
    }
  `,
  noClip: css`
    white-space: normal;
  `,
};

export const nowrap = css`
  white-space: nowrap;
`;
